import { Link } from 'react-router-dom';
import type { FC } from 'react';
import { categories } from '@/mocks/data';

const CategorySection: FC = () => {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            快速导航分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按照您的需求快速定位到相应的内容板块，高效获取所需信息和资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer text-center"
            >
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-50 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-lg`} />
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-950 font-label whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;